/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SterWebsiteModelPriceCompareLabelValuePair,
  SterWebsiteModelPriceCompareLabelValuePairFromJSON,
  SterWebsiteModelPriceCompareLabelValuePairFromJSONTyped,
  SterWebsiteModelPriceCompareLabelValuePairToJSON,
  SterWebsiteModelPriceCompareOperator,
  SterWebsiteModelPriceCompareOperatorFromJSON,
  SterWebsiteModelPriceCompareOperatorFromJSONTyped,
  SterWebsiteModelPriceCompareOperatorToJSON,
  SterWebsiteModelPriceComparePackage,
  SterWebsiteModelPriceComparePackageFromJSON,
  SterWebsiteModelPriceComparePackageFromJSONTyped,
  SterWebsiteModelPriceComparePackageToJSON,
} from "./";

/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareMetadata
 */
export interface SterWebsiteModelPriceCompareMetadata {
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareOperator>}
   * @memberof SterWebsiteModelPriceCompareMetadata
   */
  operators: Array<SterWebsiteModelPriceCompareOperator>;
  /**
   *
   * @type {Array<SterWebsiteModelPriceComparePackage>}
   * @memberof SterWebsiteModelPriceCompareMetadata
   */
  packages: Array<SterWebsiteModelPriceComparePackage>;
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareLabelValuePair>}
   * @memberof SterWebsiteModelPriceCompareMetadata
   */
  targetGroups: Array<SterWebsiteModelPriceCompareLabelValuePair>;
}

export function SterWebsiteModelPriceCompareMetadataFromJSON(
  json: any
): SterWebsiteModelPriceCompareMetadata {
  return SterWebsiteModelPriceCompareMetadataFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceCompareMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareMetadata {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    operators: (json["operators"] as Array<any>).map(
      SterWebsiteModelPriceCompareOperatorFromJSON
    ),
    packages: (json["packages"] as Array<any>).map(
      SterWebsiteModelPriceComparePackageFromJSON
    ),
    targetGroups: (json["targetGroups"] as Array<any>).map(
      SterWebsiteModelPriceCompareLabelValuePairFromJSON
    ),
  };
}

export function SterWebsiteModelPriceCompareMetadataToJSON(
  value?: SterWebsiteModelPriceCompareMetadata | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    operators: (value.operators as Array<any>).map(
      SterWebsiteModelPriceCompareOperatorToJSON
    ),
    packages: (value.packages as Array<any>).map(
      SterWebsiteModelPriceComparePackageToJSON
    ),
    targetGroups: (value.targetGroups as Array<any>).map(
      SterWebsiteModelPriceCompareLabelValuePairToJSON
    ),
  };
}
